__turbopack_context__.v({
  "ul": "index-module__UNlQlq__ul",
});
